import React , {useState} from 'react';
import { useDispatch } from 'react-redux';
import {openDeleteHrsModal, openEditHrsModal} from '../../Store/Slices/noHrsSlice';
import { PaginationDetails } from '../../Utils/Utils';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Pagination , Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';


const HoursList = ({data}) => {
    const dispatch = useDispatch();
    const { page, count, handleChange, _DATA } = PaginationDetails(data);


    const handleEdit = (noHrsId) => {
        dispatch(openEditHrsModal(noHrsId));
    };

    const handleDelete = (noHrsId) => {
        dispatch(openDeleteHrsModal(noHrsId));
    };

    const currentData = _DATA?.currentData() || data;

    const roles = sessionStorage.getItem("roles");


    return (
        <>
            <TableContainer sx={{ height: "43rem" }} >
                <Table  sx={{borderCollapse:'separate' , borderSpacing:'0px 4px' , height:'max-content'}} stickyHeader>
                    <TableHead  >
                        <TableRow >
                            <TableCell  width={50} > No Hrs Id</TableCell>
                            <TableCell  width={50}> No Of Hours </TableCell>
                            <TableCell align="center" width={"30%"}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody >
                        {currentData.map((hrs) => (
                            <TableRow  sx={{ height: "30px" }} key={hrs.noHrsId}>
                                <TableCell  component='th' scope='row' sx={{ borderBottom: "none", fontWeight: 'bold', width: 100, height: 'auto !important' }}>#{hrs.noHrsId}</TableCell>
                                <TableCell sx={{ borderBottom: "none", width: 100, height: 'auto !important' }}>{hrs.noHrs}</TableCell>
                                <TableCell align="center" sx={{ borderBottom: "none", width: '15%', height: 'auto !important' }}>
                                    {roles?.split(",").includes("PRIV_ES_EDIT_NO_HRS") ?  (<IconButton onClick={() => handleEdit(hrs.noHrsId)}>
                                        <EditIcon />
                                    </IconButton>) : null}
                                    {roles?.split(",").includes("PRIV_ES_DELETE_NO_HRS") ?  (<IconButton onClick={() => handleDelete(hrs.noHrsId)}>
                                        <DeleteIcon />
                                    </IconButton>) : null}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            
            </TableContainer>
            <Box my={2} display="flex" justifyContent="center">
                <Pagination
                    count={count}
                    page={page}
                    onChange={handleChange}
                    variant='outlined'
                    color="primary"
                    size='large'
                />
            </Box>  
        </>
    );
};


export default HoursList;